import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
    Box,
    List,
    ListItem,
    Typography,
} from '@mui/material';

import localization from '../../../localization';
import CollapsableNav from '../CollapsableNav';
import CustomScrollBar from '../../CustomScrollBar';
import NavItem from '../NavItem';
import '../SideBar.scss';

const NavItems = ({ config }) => config.items.map((item) => <NavItem key={item.id} {...item} />);

const NavListSection = ({
    curNavConfig,
    isOpenAllSections,
    setOpenAllSections,
}) => {
    const scrollBarRef = useRef(null);

    useEffect(() => {
        // when is Collapsed All clicked we should scroll on top
        if (isOpenAllSections === false) {
            scrollBarRef.current._container.scrollTop = 0;
        }
    }, [isOpenAllSections])

    return (
        <Box
            display="flex"
            flexDirection="column"
            height={1}
            justifyContent="space-between"
        >
            <Box
                display="flex"
                flexDirection="column"
                width={236}
                className="side-nav-block"
            >
                {curNavConfig.length ? (
                    <CustomScrollBar
                        scrollBarRef={scrollBarRef}
                        style={{ marginRight: '-5px' }}
                    >
                        <List sx={{ height: 'calc(100vh - 300px)' }}>
                            {curNavConfig.map((config) => (
                                <ListItem key={config.subheader || config?.items[0]?.id} disableGutters>
                                    {config.subheader ? (
                                        <CollapsableNav
                                            isOpenAllSections={isOpenAllSections}
                                            setOpenAllSections={setOpenAllSections}
                                            header={config.subheader}
                                            icon={config.subheaderIcon}
                                        >
                                            <NavItems config={config} />
                                        </CollapsableNav>
                                    ) : <NavItems config={config} />}
                                </ListItem>
                            ))}
                        </List>
                    </CustomScrollBar>
                ) : (
                    <Box mx="auto" pt={2}>
                        <Typography style={{ color: '#f3f3f3' }}>{localization.t('errorNotifications.nothingFound')}</Typography>
                    </Box>
                )}
            </Box>
        </Box>
    )
}

NavListSection.propTypes = {
    curNavConfig: PropTypes.arrayOf(PropTypes.shape({})),
    isOpenAllSections: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    setOpenAllSections: PropTypes.func,
};

export default NavListSection;
